export default __webpack_public_path__ + "static/media/donati-white.6805aba2.svg";